import { FieldType, Operator, Option } from './chips-and-fields';

// for report.schema.json -> build schema with "typescript-json-schema report.ts Reports --noExtraProps --strictNullChecks --required"
export interface Reports {
    $schema: string;
    reports: Report[];
}

export interface Report {
    id: string;
    fileName?: string;
    retrieveMethod: 'ID' | 'FILENAME';
    name: string;
    description?: string;
    parameters?: Array<Parameter>;
}

export interface Parameter {
    invisible?: boolean; // default false
    type?: FieldType; // default: text input
    defaultValue?: any;
    operator?: Operator; // if omitted -> sqlRestriction directly inserted to the selectRestriction
    formName: string;
    parameterName?: string; // if omitted -> formName
    sqlRestriction?: string; // if omitted -> not part of selectRestriction
    options?: Option[]; // options for select and radio inputs
    displayName?: string;
    order?: number; // lower value -> top placement
    required?: boolean; // default false
    keyCode?: string; // for select and radio only, generates options by keycode
    disabled?: boolean; // default false
}

export interface ReportFilter {
    key: string;
    name: string;
    value: string;
    operator: Operator;
    type: FieldType;
}

export enum ReportTask {
    PDF = 'PDF', XLS = 'XLS'
}
